import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/production-plans/reason',
    name: 'POST_PRODUCTION_PLAN_REASON',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
